import React from "react";
import BackButtons from "../common/backbuttons";
import Helmet from 'react-helmet'

class MainContributionSection extends React.Component {

    componentDidMount() {
        (function(d, sc, u) {
            var s = d.createElement(sc), p = d.getElementsByTagName(sc)[0];
            s.type = 'text/javascript';
            s.async = true;
            s.src = u + '?v=' + (+new Date());
            p.parentNode.insertBefore(s,p);
            })(document, 'script', '//aff.bstatic.com/static/affiliate_base/js/flexiproduct.js');
    }

    render() {
        // const {tagsByPosts} = this.props
        return (
            <section className="wrapper style1 align-center">
                <div className="inner" style={{paddingBottom:0}}>
                    <h2>Contribuisci</h2>
                    <p>Se preferisci, puoi contribuire al progetto acquistando prodotti consigliati oppure con una donazione.</p>
                </div>
                <div className="items style1 medium onscroll-fade-in">
                <ins className="bookingaff" data-aid="1723127" data-target_aid="1723127" data-prod="banner" data-width="200" data-height="200" data-lang="en">
                    <a href="//www.booking.com?aid=1723127">Booking.com</a>
                </ins>
                <div>
                    <h3>Paypal</h3>
                    <div>
                    <a target="_blank" href="https://www.paypal.com/pools/c/8cpOWrk9sJ"><img src="https://www.paypalobjects.com/it_IT/IT/i/btn/btn_donate_LG.gif" alt="0" /></a>
                    <br/>
                    <a target="_blank" href="https://www.paypal.com/pools/c/8cpOWrk9sJ"><img src="https://www.paypalobjects.com/webstatic/mktg/logo-center/logo_paypal_carte.jpg" border="0" alt="Marchi di accettazione PayPal"/></a>
                    </div>
                </div>
                </div>
                <BackButtons backElement="galleryElements"/>
            </section>
        )
    }
}
export default MainContributionSection